import { useContext } from 'react';
import { ViewTypeContext } from '../contexts/viewTypeContext';

export const useViewType = () => useContext(ViewTypeContext);
